import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatTile = createCustomElementWrapper('kat-tile', 'KatTile', {
    'imageHeight': 'image-height',
}, {
    'onClick': 'click',
    'onSelected': 'selected',
});
